import type { HARRequest } from './api/mapHarEntryToHarRequest';
import { useHarEntryBodyViewFromShape } from './useHarEntryBodyView';

export function useHttpHistoryGrpcBodyView({
  applicationId,
  harRequest,
}: {
  applicationId?: string;
  harRequest: HARRequest | null;
}) {
  const display = useHarEntryBodyViewFromShape({
    applicationId,
    harEntryShape: harRequest?.grpcHarDisplay,
    viewResetKey: harRequest?.id,
  });

  return {
    bodyView: display.bodyView,
    setBodyView: display.setBodyView,
    grpcHarDisplay: display.harEntry ?? undefined,
    harEntry: display.harEntry ?? undefined,
    hasGrpcHarEntry: display.hasHarEntry,
    hasGrpcBodyView: display.hasDecodedBodyView,
    showGrpcBodyViewToggle: display.showProtocolBodyViewToggle,
    showProtocolBodyViewToggle: display.showProtocolBodyViewToggle,
    editorProps: display.editorProps,
  };
}
